import Vue from 'vue'
/**
 * 设置基础URL
 */
let base = '/apiv1/auth'

/**
 * 查询角色用户列表
 */
export const queryRoleUser = (params) => {
  return Vue.fetch.post(`${base}/queryRoleUser`, params)
}

/**
 * 删除角色用户列表
 */
export const removeUserRole = (params) => {
  return Vue.fetch.post(`${base}/removeUserRole`, params)
}

/**
 * 更新角色资源树形
 */
export const updateRoleResource = (params) => {
  return Vue.fetch.post(`${base}/updateRoleResource`, params)
}

/**
 * 获取登录用户的资源树
 */
export const queryUserResourceTree = (params) => {
  return Vue.fetch.post(`${base}/queryUserResourceTree`, params)
}
/**
 * 获取角色有权限的资源列表
 */
export const queryRoleResourceList = (params) => {
  return Vue.fetch.post(`${base}/queryRoleResourceList`, params)
}



// WEBPACK FOOTER //
// ./src/cdpBase/services/auth.js